import { render, staticRenderFns } from "./epfveNew.vue?vue&type=template&id=5d9dfecc"
import script from "./epfveNew.vue?vue&type=script&lang=js"
export * from "./epfveNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports